import React, { Children } from 'react';
import PropTypes from 'prop-types';

import { Background, Wrapper, FullHeightRow, FullHeightCol } from './styled-components';

const Paper = ({ children }) => (
  <Wrapper>
    <Background>
      <FullHeightRow>
        {Children.map(children, (child, i) => (
          <FullHeightCol key={i} xs={12}>
            {child}
          </FullHeightCol>
        ))}
      </FullHeightRow>
    </Background>
  </Wrapper>
);

Paper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default Paper;



// WEBPACK FOOTER //
// ./src/views/common/components/Paper/index.jsx